import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#01916D', //アドバンスドグリーン100%
      light: '#CCE9E2', //アドバンスドグリーン20%
      // #01916D:アドバンスドグリーン100%
      // #34A78A:アドバンスドグリーン80%
      // #67BDA7:アドバンスドグリーン60%
      // #99D3C5:アドバンスドグリーン40%
      // #CCE9E2:アドバンスドグリーン20%
      // #E6F4F0:アドバンスドグリーン10%
      // #014937:アドバンスドグリーン+K60%
    },
    secondary: {
      main: '#99D3C5', //アドバンスドグリーン40%
      light: '#E6F4F0', //アドバンスドグリーン10%
    },
    success: {
      main: '#1E83BE', // ブルー100%
      light: '#D2E6F2', //ブルー20%
      // #1E83BE:ブルー100%
      // #4B9CCB:ブルー80%
      // #78B5D8:ブルー60%
      // #A5CDE5:ブルー40%
      // #D2E6F2:ブルー20%
      // #E8F3F8:ブルー10%
      // #0F425F:ブルー+K60%
    },
    warning: {
      main: '#EA5504', //オレンジ100%
      light: '#FBDDCD', //オレンジ20%
      // #EA5504:オレンジ100%
      // #EE7736:オレンジ80%
      // #F29968:オレンジ60%
      // #F7BB9B:オレンジ40%
      // #FBDDCD:オレンジ20%
      // #FDEEE6:オレンジ10%
      // #752B02:オレンジ+K60%
    },
    error: {
      main: '#E0356C', // ピンク100%
      light: '#F3AEC4', // ピンク40%
      // #E0356C:ピンク100%
      // #E65D89:ピンク80%
      // #EC86A7:ピンク60%
      // #F3AEC4:ピンク40%
      // #F9D7E2:ピンク20%
      // #FCEBF0:ピンク10%
      // #701B36:ピンク+K60%
    },
    grey: {
      900: '#333333', //イノベーティブグレー100%
      800: '#5C5C5C', //イノベーティブグレー80%
      600: '#858585', //イノベーティブグレー60%
      500: '#858585', //イノベーティブグレー60%
      400: '#ADADAD', //イノベーティブグレー40%
      200: '#D6D6D6', //イノベーティブグレー20%
      100: '#EBEBEB', //イノベーティブグレー10%
    },
    background: {
      default: '#FFFFFF',
      paper: '#FAFAFA',
    },
  },
  typography: {
    body1: {
      fontSize: '0.9rem',
    },
    button: {
      fontSize: '0.875rem',
    },
    caption: {
      fontSize: '0.75rem',
      fontWeight: 'normal',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none', // テキストを大文字にしない
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none', // テキストを大文字にしない
        },
      },
    },
  },
});
